import { apiClient } from '@/lib/api-client';
import { GlobalDashboardApiDatasource } from '../data/datasources/global-dashboard-api.datasource';
import { GlobalDashboardRepositoryImpl } from '../data/repositories/global-dashboard.repository.impl';

const apiDatasource = new GlobalDashboardApiDatasource(apiClient);
const repository = new GlobalDashboardRepositoryImpl(apiDatasource);

export const globalDashboardContainer = { repository };
